import { sanitizeDealPromptFormatAndDevices } from '@openx/components-deal-prompt/lib/utils/filters/sanitizeDealPromptFormatAndDevices';
import type { DealPromptFilters } from '@openx/components-deal-prompt/lib/utils/types';
import { type CriteriaChange, CriteriaDimension } from '@openx/types/tableCriteria';
import { applyCriteriaChange } from '@openx/utils/lib/tableCriteria';
import isEqual from 'lodash/isEqual';
import { useCallback } from 'react';
import { type DefaultTableCriteria, useListCriteria } from '../../../utils/useListCriteria';

export const useDealPromptFilters = () => {
  const { criteria, setCriteria } = useListCriteria('dealPrompt', {
    filters: {},
  } as DefaultTableCriteria<'dealPrompt'>);

  const handleFiltersChange = useCallback(
    (value: DealPromptFilters) => {
      const normalized = sanitizeDealPromptFormatAndDevices(value, criteria.filters);

      const newCriteria: CriteriaChange<CriteriaDimension, DealPromptFilters> = {
        dimension: CriteriaDimension.FILTERS,
        value: normalized,
      };

      const newCriteriaProcessed = applyCriteriaChange(criteria, newCriteria);

      if (!isEqual(newCriteriaProcessed, criteria)) {
        setCriteria(newCriteriaProcessed);
      }
    },
    [criteria, setCriteria]
  );

  return { criteria, handleFiltersChange };
};
